import PropTypes from 'prop-types';
import React from 'react'
import { Link } from 'react-router-dom'
import classNames from 'classnames'


export default class extends React.Component {
    static propTypes = {
		members: 		PropTypes.number,
		owner: 			PropTypes.object.isRequired,
		sample_users: 	PropTypes.array
	};

    createUser = (user, mayor) => {
		return <div className={"camp-user" + (!!mayor ? ' mayor' : '')} key={user.ID}>
			<Link to={user.link}>
				{ !mayor && <div className={"overlay min " + (this.props.owner.ID == user.ID ? 'overlay-white' : 'overlay-light-main')}></div> }
        		<div className="profile-image" style={{backgroundImage: 'url(' + user.profile_picture + ')'}}></div>
    		</Link>
		</div>
	};

    render() {

		return (
			<div>
				<div className="camp-user-holder pbot20">
					{ this.createUser(this.props.owner, true) }
				</div>
				<div className="clearfix"></div>
				<div className="camp-user-holder">
					{ this.props.sample_users.length > 0 &&
						this.props.sample_users.map(this.createUser, false)
					}
					{ this.props.sample_users.length >= 4 &&
						<div className="camp-user" key={'plus-more'}>
							<div className="overlay overlay-light-main max"></div>
							<div className="profile-image plus-more">
								<p>+{ +this.props.members - this.props.sample_users.length - 1 }</p>
							</div>
						</div>
					}
				</div>
			</div>
		)

	}
}



// WEBPACK FOOTER //
// ./src/js/views/Community/CampParts/HeaderParts/HeaderPart-Users.jsx